import { queryOptions } from "@tanstack/react-query";
import { fetchAllPerfumes, fetchProductBySlug } from "@/lib/shopify";

export const allPerfumesQueryOptions = queryOptions({
  queryKey: ["shopify-perfumes", "storefront-2025-07-v4"],
  queryFn: fetchAllPerfumes,
  staleTime: 5 * 60 * 1000,
});

/**
 * Keyed by the canonical URL slug. `fetchProductBySlug` walks the alias list
 * defined in `SHOPIFY_HANDLE_ALIASES`, so the cache key stays stable even if
 * the upstream Shopify handle changes.
 */
export const productByHandleQueryOptions = (slug: string | undefined) =>
  queryOptions({
    queryKey: ["shopify-product", "storefront-2025-07-v4", slug],
    queryFn: () => (slug ? fetchProductBySlug(slug) : Promise.resolve(null)),
    enabled: !!slug,
    staleTime: 5 * 60 * 1000,
  });
